export const mergeAndCleanParams = <T extends object>(
  params: T,
  defaultParams: T
) => {
  // merge params with default values
  const mergedParams = { ...defaultParams, ...params };

  // remove undefined values
  Object.keys(mergedParams).forEach(
    (key) =>
      mergedParams[key as keyof T] === undefined &&
      delete mergedParams[key as keyof T]
  );

  // convert the mergedParams object to a query string
  const queryString = Object.entries(mergedParams)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join("&");

  return queryString;
};
